import { useState } from '@hookstate/core';

import { useCreateTicketState } from '@store/hookstate';

import CloseImage from '@assets/svg/close-ticket.svg';
import MinimizeImage from '@assets/svg/minimize-ticket.svg';
import MaximizeImage from '@assets/svg/maximize-ticket.svg';

import { EquipmentBar, TicketForm } from './components';

import {
  Container,
  Head,
  Title,
  WindowButton,
  WindowButtons,
  WindowButtonImage,
  FormContainer,
} from './CreateTicket.styles';

const CreateTicket = () => {
  const createTicketState = useCreateTicketState();

  const maximized = useState(true);

  return (
    <Container>
      <Head>
        <Title>New Support Ticket</Title>

        <div style={{ width: 27 }} />
        <WindowButtons>
          <WindowButton onClick={() => maximized.set(old => !old)}>
            {maximized.get() ? (
              <WindowButtonImage src={MinimizeImage} />
            ) : (
              <WindowButtonImage src={MaximizeImage} />
            )}
          </WindowButton>
          <div style={{ width: 27 }} />
          <WindowButton onClick={createTicketState.closeCreateTicket}>
            <WindowButtonImage src={CloseImage} />
          </WindowButton>
        </WindowButtons>
      </Head>

      <div style={{ height: 16 }} />
      <EquipmentBar />

      <FormContainer active={maximized.get()}>
        <div style={{ height: 24 }} />
        <TicketForm />
      </FormContainer>
    </Container>
  );
};

export { CreateTicket };
